module.exports = __webpack_public_path__ + "static/media/share-alt-square.1da8dd3d.svg";